import { createContext, useContext } from "react";

/**
 * Czy OTWARTA rozmowa leci w trybie YOLO (autopilot).
 *
 * W tym trybie ARON nie pokazuje kart do zatwierdzenia — zapisy idą do bazy od
 * razu. Cała oprawa rozmowy przestaje wtedy być czerwona i robi się czarna, żeby
 * z drugiego końca biurka było widać, że to nie jest zwykły wątek.
 */
export const AronYoloContext = createContext(false);

export const useAronYolo = () => useContext(AronYoloContext);
